/* eslint-disable max-nested-callbacks */
import { Modal,message } from 'antd';
import React, { useEffect,useState } from 'react';
import {queryInstanceDetailsV3,queryRecommendedImageList} from '../../../shared/api';
import './index.scss';
import cls from 'classnames';
import Default from '@/assets/images/desktop/common/default.jpg';
import arrow1 from '@/assets/images/desktop/common/right_arrow1.png';
import arrow2 from '@/assets/images/desktop/common/right_arrow2.png';
import $ from 'jquery';
const pre = window.ENV_IMG_PREURL_SRC;

const InstanceBox = ({instanceStr,time}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [instanceData, setInstanceData] = useState();
  const [recommendData, setRecommendData] = useState([]);
  useEffect(() => {
    if(instanceStr){
        setIsModalOpen(true);
        setInstanceData(null);
        setRecommendData([]);
        const arr = instanceStr ? instanceStr.split(',') : [];
        const params = {
            conceptCode: arr[0],
            instanceName: arr[1]
        }
        queryInstanceDetailsV3(params).then((res) => {
            if(res && res.instanceId){
                let count = 0;
                res['attrs'] = [];
                res?.attrFields?.map((item,index) => {
                    let name;
                    res?.attrTriples?.forEach(i => {
                        if (i.englishCode == item) {
                            name = i.relationshipName;
                        }
                    })
                    const val = res?.properties[item];
                    if(name && val && count<=3){
                        count += 1;
                        res['attrs'].push({name:name,val:val})
                    }
                })
                if(res && res.instanceId){
                    queryRecommendedImageList({
                        current: 1,
                        size: 3,
                        conceptCodes: [res.conceptCode],
                        instanceId: res.instanceId,
                        instanceName: res.instanceName
                      }).then((data) => {
                        setInstanceData(res);
                        setRecommendData(data.records);
                    });
                }else{
                    setRecommendData([]);
                }
            }else{
                setIsModalOpen(false);
                message.error('数据获取失败！');
            }
        });
    }
  }, [time])

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal className='instance-modal' visible={isModalOpen} onCancel={handleCancel}>
      <div className='container'>
      {
        instanceData && <div className='content' id='instanceInfo'>
            <div className="title">
                <span>{instanceData.instanceName}</span>
                <a href={'/Subject/null/'+instanceData.instanceId} target='_blank' className="btn-link instance-link">
                查看详情
                <img src={arrow1}/>
                </a>
                <a href={'/Relation?centersearch='+instanceData.instanceName} target='_blank' className="btn-link relation-link">
                查看图谱
                <img src={arrow2}/>
                </a>
            </div>
            <div className='attrs'>
                {
                    instanceData?.attrs?.map((item,index) => {
                        return (
                            <p key={index}><span>{item.name}：</span><span>{item.val}</span></p>
                          )
                    })
                }
            </div>
            <div className="desc"
                dangerouslySetInnerHTML={{ __html: instanceData.properties.description }}
            />
            {
                recommendData && 
                <>
                <div className="section-title section-recommend">
                    <h3>相关推荐</h3>
                </div>
                <div className="relavant">
                    {
                        recommendData?.map((item,index) => {
                            return (
                                <a className="relavant-link" href={'/Subject/null/'+item.instanceId} target="_blank" key={index}>
                                    <div className="cover Person">
                                        <img src={item.showImage ? pre+'/'+item.showImage : Default} alt=""/>
                                    </div>
                                    <h3 className="link-title">{item.instanceName}</h3>
                                </a>
                            )
                        })
                    }
                </div>
                </>
            }
            </div>
      }
      </div>
    </Modal>
  );
};
export default InstanceBox;
